import { render, staticRenderFns } from "./TextAreaDesigner.vue?vue&type=template&id=e4236ae8&scoped=true&"
import script from "./TextAreaDesigner.vue?vue&type=script&lang=js&"
export * from "./TextAreaDesigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4236ae8",
  null
  
)

export default component.exports